import React, { useEffect } from 'react'
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'

import { uploadFileTypeIsValid } from 'app/utils/fieldUtils'
import errorMessages from 'app/utils/errorMessages'
import { fetchChunkedUploadProperties, uploadFile } from 'app/actions/chunkedUploadActions'

import LgyFileInputField from '../lgy-input-field/LgyFileInputField'
import './lgy-file-upload.scss'

/**
 * 
 * @author Sriram Jaini
 * @prettier
 * 
 */
const minMaxFileSize = file => {
  const { size } = file || {}
  return (size === 0 || size > 104857600) ? errorMessages.salesContract.fileSize: undefined
}

const invalidFileType = file => {
  const { name } = file || {}
  return !uploadFileTypeIsValid(name) ? errorMessages.salesContract.fileType: undefined
}

const submitFile = (values, dispatch, props) => async () => {
  const {file} = values
  const chunkSize = props.properties?.preferredChunkSize
  dispatch({type:'INIT_SALES_CONTRACT'})
  dispatch({type:'CHUNK_RESET_ERROR'})
  dispatch({type:'INIT_CHUNK_RESET_ERROR'})
  dispatch(uploadFile(file, chunkSize))
}

let LgyFileUpload = ({ properties, fetchChunkedUploadProperties,  ...reduxForm }) => {
  const { handleSubmit, submitting } = reduxForm

  useEffect(() => {
    if (!properties) {
      console.log('Do not have file upload properties')
      fetchChunkedUploadProperties()
    }
  })
  return (
    <form onSubmit={handleSubmit} className='usa-form'>
      <Field label='Sales Contract' id='lgyFileUpload' disabled={submitting} name='file' accept='.pdf, .doc, .docx, .xlsx, .xls, .tif, .tiff, .gif, .jpg, .jpeg, .png' component={LgyFileInputField} format={null} validate={[minMaxFileSize, invalidFileType]} customClass='customFileSelection'/>
    </form>
  )
}

LgyFileUpload = reduxForm()(LgyFileUpload)

const mapStateToProps = state => ({
  properties: state.chunkedUploads.properties
})

const mapDispatchToProps = {
  onSubmit: submitFile,
  fetchChunkedUploadProperties
}

LgyFileUpload = connect(mapStateToProps, mapDispatchToProps)(LgyFileUpload)


export default LgyFileUpload